export const ShiftTradeEmployerRoutes = [
    {
        "url": "/shift-trading",
        "name": "appLayout.schedule.shift-trading",
        "showGlobalSearch": true,
        "type": "frontend",
        "loginRequired": true,
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Requests"
            }
        ],
        "views": {
            "body": {
                "component": "shiftTradeEmployer"
            }
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/shift-trade/shift-trade.downgrade.module");
                }
            }
        ],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["shift_trade"]
        },
    }
];
//# sourceMappingURL=shift-trade-employer.routes.js.map